import React from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import ru from 'date-fns/locale/ru';

const DatePickerInput = ({ value, onChange, placeholder, minDate, maxDate }) => {
  return (
    <DatePicker
      selected={value ? new Date(value) : null}
      onChange={(date) => onChange({ target: { value: date } })}
      dateFormat="dd.MM.yyyy"
      placeholderText={placeholder}
      locale={ru}
      minDate={minDate}
      maxDate={maxDate}
      className="date-picker-input"
    />
  );
};

export default DatePickerInput; 